// Object-catalog client: a database's tables→columns (with enum values),
// triggers (with bodies), and routines (with call-ready signatures) in one call.
// Powers the Object Viewer (Ctrl+F12). Returns:
//   { database, tables:[{name,view,columns:[{name,type,pk,nullable,enum?}]}],
//     triggers:[{name,table,timing,event,statement}],
//     routines:[{name,kind,signature,returns}] }
import { api } from './api.js';

export const fetchObjectCatalog = (connectionId, database) =>
  api.get(`/api/connections/${connectionId}/databases/${encodeURIComponent(database)}/object-catalog`);
